import MasterConfig from './master-backend-api-config';
import DevConfig from './dev-api-config';

const env = process.env.NODE_ENV;
const Config = env === 'production' || process.env.REACT_APP_USE_PROD ? MasterConfig : DevConfig;
export default Config;
